import {motion} from 'framer-motion';
import Stack from '@mui/material/Stack';

const AnimateStack = motion(Stack);

export default AnimateStack;
